import utils from '@/plugins/TravellerUtils';

const documents = {
    namespaced: true,
    state: {
        documentOptionList: {
            listData: []
        },
        validityBegins: null,
        validityEnds: null,
        documentToken: null
    },
    mutations: {
        setDocumentOptionListData(state, entries) {
            state.documentOptionList.listData = entries;
        },
        setDocumentToken(state, token) {
            state.documentToken = token;
        },
        clearDocumentToken(state) {
            state.documentToken = null;
        }
    },
    actions: {
        getDocumentOptions(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get(`/traveller/restui/documentManagement/listDocumentOptions`)
                    .then(resp => {
                        if (utils.checkResponseIsArray(resp)) {
                            context.commit('setDocumentOptionListData', resp.data);
                            resolve();
                        } else {
                            reject('Unexpected response format');
                        }
                    })
                    .catch(error => {
                        console.error('Failed to fetch document options:', error);
                        reject(error);
                    });
            });
        },
        sendDocument(context, documentData) {
            let formData = new FormData();
            formData.append('filedata', documentData);
            formData.append('filename', documentData.name);
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http
                    .post('/traveller/restui/documentManagement/uploadFile', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    .then(response => {
                        if (utils.checkResponseObjectWithMemeber(response, 'message')) {
                            context.commit('setDocumentToken', response.data.message);
                            resolve();
                        } else {
                            context.commit('clearDocumentToken');
                            reject();
                        }
                    })
                    .catch(error => {
                        context.commit('clearDocumentToken');
                        reject(error);
                    });
            });
        },
        submitDocumentData(context, documentData) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http
                    .post('/traveller/restui/documentManagement/editDocument', documentData, {
                        headers: { 'Content-Type': 'application/json' }
                    })
                    .then(response => {
                        if ([0, 200, 201].includes(response.data.errorCode)) {
                            resolve();
                        } else {
                            reject(new Error('Invalid response errorCode'));
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        removeDocumentOption(context, id) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http
                    .delete('/traveller/restui/documentManagement/deleteDocumentOption?id=' + id)
                    .then(response => {
                        if (utils.checkResponseIsOk(response)) {
                            resolve();
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    },
    getters: {
        documentToken: state => state.documentToken
    }
};

export default documents;
